import { SafeAreaView, ScrollView, StyleSheet, Text, View } from "react-native";
import React, { useEffect, useState } from "react";
import Header from "../../../components/Header";
import Announcements from "../../../components/Announcements";
import { useAppSelector } from "../../../hooks/reduxHooks";
import useApi from "../../../hooks/useAPI";
import { useQuery } from "react-query";
import DiscountsPerCategoryCard from "../../../components/DiscountsPerCategoryCard/DiscountsPerCategoryCard";
import ExclusiveDiscounts from "../../../components/ExclusiveDiscounts";

const DiscountsScreen = () => {
  const api = useApi();
  const { data: highlightDiscountsIds } = useQuery(
    "highlightDiscountsIDs",
    api.discounts.getHighlightsDiscountsId
  );
  const discounts = useAppSelector((s) => s.discounts);

  return (
    <SafeAreaView style={styles.root}>
      <Header />

      <ScrollView style={styles.scrollView}>
        <View style={styles.wrap}>
          <Announcements
            title={"Destaques"}
            announcements={discounts
              .filter((d) => d.bannerImageId?.length > 0)
              .filter((d) =>
                highlightDiscountsIds
                  ? highlightDiscountsIds?.data.includes(d.id)
                  : true
              )}
            type="discounts"
            seeAllButton={false}
            highlight
          />
          <DiscountsPerCategoryCard title={"Escolha a categoria"} />
          <Text style={styles.title}>Descontos exclusivos ISIC</Text>
          <ExclusiveDiscounts />
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default DiscountsScreen;

const styles = StyleSheet.create({
  root: {
    flex: 1,
  },
  scrollView: {
    flex: 1,
  },
  wrap:{
    marginTop:10
  },
  title: {
    fontWeight: "500",
    fontSize: 16,
    marginBottom: 12,
    marginHorizontal: "5%",
  },
});
